import { Navigate } from 'react-router-dom';

export const Home = () => {
  return <Navigate to='/plus/cart-history' />;
};
